import React from "react";
import { connect } from "react-redux";
import ReactLoading from "react-loading";
import {
  loginAction,
  addPermission,
} from "../../services/redux/actions/loginActions";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobileOnly,
} from "react-device-detect";
import "../../static/css/loading.css";
import { AUTHENTICATE_USER_BY_TOKEN } from "../../services/graphql/queries/auth";
import { SET_TIMEOUT_VALUE } from "../../utils/app-constants";
import queryString from "query-string";
import { withApollo } from "react-apollo";
// import DisplayErrors from "../Common/DisplayErrors";
import { withRouter } from "react-router-dom";

class InfoPortal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      authDetail: {},
      errors: [],
      loading: false,
    };
  }

  authUserByToken() {
    // this.setState({ errors: [], loading: true });
    console.log("here");
    this.props.client
      .mutate({
        mutation: AUTHENTICATE_USER_BY_TOKEN,
        variables: {
          userAgent: navigator.userAgent,
          ipAddress: "",
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        console.log("result~~~", result);
        localStorage.setItem(
          "token",
          result.data.authenticateUserByToken.token
        );
        localStorage.setItem("userType", 4);
        localStorage.setItem("commonLogin", true);
        this.props.dispatch(
          loginAction(result.data.authenticateUserByToken.name)
        );
        this.props.dispatch(addPermission({}));
        if (isMobileOnly) {
          this.props.history.push("/mobile-home");
        } else {
          this.props.history.push("/home");
        }

        // this.props.history.push("/users-view");
      })
      .catch((error) => {
        this.setState({
          errors: error,
          loading: false,
        });

        setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });

    // this.setState({ disabled: false });
  }
  componentDidMount() {
    this.setState({ loading: true });
    const authToken = queryString.parse(this.props.location.search).token;
    localStorage.setItem("token", authToken);
    localStorage.setItem("userType", 4);
    this.authUserByToken();
  }
  render() {
    const { errors, loading } = this.state;
    return (
      <>
        {loading ? (
          <ReactLoading
            className="loading-screen"
            type="bubbles"
            color="#69951a"
            height="12%"
            width="12%"
          />
        ) : (
          <div className="row">
            <div className="col-lg-12 text-center mt-4">
              <h2>Unauthorised Access</h2>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default connect()(withRouter(withApollo(InfoPortal)));
